export default __webpack_public_path__ + "static/media/Aliker.8b84967f.png";